// extracted by mini-css-extract-plugin
export default {"label":"File_label__eZm9a","tooltip":"File_tooltip__+afrG","wrap":"File_wrap__xEzgv","input":"File_input__Oz88s","box":"File_box__dGWar"};